import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Shop from './Pages/Shop';
import Cart from './Pages/Cart';
import LoginSignUp from './Pages/LoginSignUp';
import ShopCategory from './Pages/ShopCategory';
import Product from './Pages/Product';
import medical_banner from './Components/Assets/banner_mens.png';
import lab_banner from './Components/Assets/banner_women.png';
import reagent_banner from './Components/Assets/banner_mens.png';
import chemical_banner from './Components/Assets/banner_kids.png';
import Footer from './Components/Footer/Footer';
import ShowcontextProvider from './Context/ShopContext';

function App() {
  return (
    <div>
      <ShowcontextProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Shop />} />
            
            {/* Main Category Routes */}
            <Route 
              path="/medical" 
              element={<ShopCategory banner={medical_banner} category="medical" />} 
            />
            <Route 
              path="/lab" 
              element={<ShopCategory banner={lab_banner} category="lab" />} 
            />
            <Route 
              path="/reagent" 
              element={<ShopCategory banner={reagent_banner} category="reagent" />} 
            />
            <Route 
              path="/chemical" 
              element={<ShopCategory banner={chemical_banner} category="chemical" />} 
            />
            
            {/* Subcategory Routes */}
            <Route 
              path="/:category/:subcategory" 
              element={<ShopCategory banner={medical_banner} />} 
            />
            
            <Route path="/product/:productId" element={<Product />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/login" element={<LoginSignUp />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </ShowcontextProvider>
    </div>
  );
}

export default App;